var U = (t, e, n) => {
  if (!e.has(t))
    throw TypeError("Cannot " + n);
};
var c = (t, e, n) => (U(t, e, "read from private field"), n ? n.call(t) : e.get(t)), u = (t, e, n) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, n);
}, l = (t, e, n, r) => (U(t, e, "write to private field"), r ? r.call(t, n) : e.set(t, n), n);
import { createTimer as w, createSlice as o, createContainer as pe, createClock as Ee, Ctx as ke, Pre as Re } from "@milkdown/ctx";
export * from "@milkdown/ctx";
import { docTypeError as Se, callCommandBeforeEditorView as Oe } from "@milkdown/exception";
import { PluginKey as H, Plugin as J, EditorState as Me } from "@milkdown/prose/state";
import { EditorView as Ve } from "@milkdown/prose/view";
import { customInputRules as ve } from "@milkdown/prose";
import { baseKeymap as Pe } from "@milkdown/prose/commands";
import { keymap as be } from "@milkdown/prose/keymap";
import { Schema as De, DOMParser as Ke, Node as Ne } from "@milkdown/prose/model";
import { remark as le, createParser as ze, createSerializer as Ie } from "@milkdown/transformer";
export * from "@milkdown/transformer";
import { createThemeManager as _e, emotionConfigCtx as X, emotionCtx as z, themeManagerCtx as ue, initEmotion as Le, internalThemeKeys as we, ThemeGlobal as Ae } from "@milkdown/design-system";
export * from "@milkdown/design-system";
const I = w("ConfigReady"), We = (t) => (e) => (e.record(I), async (n) => {
  await t(n), n.done(I);
}), Y = o([], "themeTimer"), _ = w("ThemeEnvironmentReady"), F = w("ThemeReady"), $e = new H("MILKDOWN_THEME_RESET"), qe = (t) => {
  const e = _e();
  return t.inject(X).inject(z).inject(ue, e).inject(Y, [I]).record(F).record(_), async (n) => {
    await n.waitTimers(Y);
    const r = Le(n.get(X));
    we.forEach((i) => {
      e.inject(i);
    }), n.set(z, r), n.done(_), await n.wait(R), n.update(S, (i) => i.concat(new J({
      key: $e,
      view: () => (e.runExecutor(), {
        destroy: () => {
          r.flush();
        }
      })
    })));
  };
}, gt = (t) => {
  let e = null;
  const n = () => async (r) => {
    await r.wait(_);
    const i = r.get(z), a = r.get(ue);
    a.setExecutor(() => {
      t == null || t(i, a), e == null || e(i, a), we.forEach((h) => {
        a.has(h) || console.warn("Theme key not found: ", h.sliceName);
      }), a.get(Ae, void 0);
    }), r.done(F);
  };
  return n.override = (r) => (e = r, n), n;
}, R = w("InitReady"), Z = o([], "initTimer"), Be = o({}, "editor"), ge = o([], "inputRules"), S = o([], "prosePlugins"), ye = o([], "remarkPlugins"), Ce = o([], "nodeView"), fe = o([], "markView"), O = o(le(), "remark"), Ge = (t) => (e) => (e.inject(Be, t).inject(S).inject(ye).inject(ge).inject(Ce).inject(fe).inject(O, le()).inject(Z, [F]).record(R), async (n) => {
  await n.waitTimers(Z), n.done(R);
}), M = w("schemaReady"), V = o({}, "schema"), x = o([], "schemaTimer"), D = o([], "nodes"), K = o([], "marks"), ee = (t) => {
  var e;
  return {
    ...t,
    parseDOM: (e = t.parseDOM) == null ? void 0 : e.map((n) => ({ priority: t.priority, ...n }))
  };
}, He = (t) => (t.inject(V).inject(D).inject(K).inject(x, [R]).record(M), async (e) => {
  await e.waitTimers(x);
  const n = e.get(O), i = e.get(ye).reduce((d, s) => d.use(s), n);
  e.set(O, i);
  const a = Object.fromEntries(e.get(D).map(([d, s]) => [d, ee(s)])), h = Object.fromEntries(e.get(K).map(([d, s]) => [d, ee(s)]));
  e.set(V, new De({
    nodes: a,
    marks: h
  })), e.done(M);
}), L = o(() => {
}, "parser"), te = o([], "parserTimer"), A = w("ParserReady"), Je = (t) => (t.inject(L).inject(te, [M]).record(A), async (e) => {
  await e.waitTimers(te);
  const n = e.get(D), r = e.get(K), i = e.get(O), a = e.get(V), h = [
    ...n.map(([s, p]) => ({ id: s, ...p })).map((s) => ({ ...s, is: "node" })),
    ...r.map(([s, p]) => ({ id: s, ...p })).map((s) => ({ ...s, is: "mark" }))
  ], d = Object.fromEntries(h.map(({ id: s, parseMarkdown: p, is: C }) => [s, { ...p, is: C, key: s }]));
  e.set(L, ze(a, d, i)), e.done(A);
}), ne = o(() => "", "serializer"), re = o([], "serializerTimer"), W = w("SerializerReady"), Fe = (t) => (t.inject(ne).inject(re, [M]).record(W), async (e) => {
  await e.waitTimers(re);
  const n = e.get(D), r = e.get(K), i = e.get(O), a = e.get(V), h = [...n, ...r], d = Object.fromEntries(h.map(([s, p]) => [s, p.toMarkdown]));
  e.set(ne, Ie(a, d, i)), e.done(W);
}), oe = o("", "defaultValue"), b = o({}, "editorState"), se = o((t) => t, "stateOptions"), ie = o([], "editorStateTimer"), $ = w("EditorStateReady"), Qe = new H("MILKDOWN_STATE_TRACKER"), Ue = (t, e, n) => {
  if (typeof t == "string")
    return e(t);
  if (t.type === "html")
    return Ke.fromSchema(n).parse(t.dom);
  if (t.type === "json")
    return Ne.fromJSON(n, t.value);
  throw Se(t);
}, Xe = (t) => (t.inject(oe).inject(b).inject(se).inject(ie, [A, W, G]).record($), async (e) => {
  await e.waitTimers(ie);
  const n = e.get(V), r = e.get(L), i = e.get(ge), a = e.get(se), h = e.get(S), d = e.get(oe), s = Ue(d, r, n), p = [
    ...h,
    new J({
      key: Qe,
      state: {
        init: () => {
        },
        apply: (je, N, ot, Te) => {
          e.set(b, Te);
        }
      }
    }),
    ve({ rules: i }),
    be(Pe)
  ];
  e.set(S, p);
  const C = a({
    schema: n,
    doc: s,
    plugins: p
  }), m = Me.create(C);
  e.set(b, m), e.done($);
}), q = o({}, "editorView"), ae = o({}, "editorViewOptions"), ce = o(null, "root"), me = o([], "editorViewTimer"), B = w("EditorViewReady"), Ye = (t) => {
  const e = document.createElement("div");
  return e.className = "milkdown", t.appendChild(e), e;
}, Ze = (t) => {
  t.classList.add("editor"), t.setAttribute("role", "textbox");
}, xe = new H("MILKDOWN_VIEW_CLEAR"), et = (t) => (t.inject(ce, document.body).inject(q).inject(ae).inject(me, [$]).record(B), async (e) => {
  await e.wait(R);
  const n = e.get(ce) || document.body, r = typeof n == "string" ? document.querySelector(n) : n;
  e.update(S, (p) => [
    new J({
      key: xe,
      view: (C) => {
        const m = r ? Ye(r) : void 0;
        return (() => {
          if (m && r) {
            const N = C.dom;
            r.replaceChild(m, N), m.appendChild(N);
          }
        })(), {
          destroy: () => {
            m != null && m.parentNode && (m == null || m.parentNode.replaceChild(C.dom, m)), m == null || m.remove();
          }
        };
      }
    }),
    ...p
  ]), await e.waitTimers(me);
  const i = e.get(b), a = e.get(ae), h = Object.fromEntries(e.get(Ce)), d = Object.fromEntries(e.get(fe)), s = new Ve(r, {
    state: i,
    nodeViews: h,
    markViews: d,
    ...a
  });
  Ze(s.dom), e.set(q, s), e.done(B);
});
var f, g;
class tt {
  constructor() {
    u(this, f, void 0);
    u(this, g, void 0);
    l(this, f, pe()), l(this, g, null), this.setCtx = (e) => {
      l(this, g, e);
    };
  }
  create(e, n) {
    return e(c(this, f).sliceMap, n);
  }
  get(e) {
    return c(this, f).getSlice(e).get();
  }
  call(e, n) {
    if (c(this, g) == null)
      throw Oe();
    const i = this.get(e)(n), a = c(this, g).get(q);
    return i(a.state, a.dispatch, a);
  }
}
f = new WeakMap(), g = new WeakMap();
const yt = (t, e) => [t, e], Ct = (t = "cmdKey") => o(() => () => !1, t), nt = o({}, "commands"), de = o([], "commandsTimer"), G = w("CommandsReady"), rt = (t) => {
  const e = new tt();
  return t.inject(nt, e).inject(de, [M]).record(G), async (n) => {
    await n.waitTimers(de), n.done(G), await n.wait(B), e.setCtx(n);
  };
};
var j, T, E, k, y, v, P;
const Q = class {
  constructor() {
    u(this, j, void 0);
    u(this, T, void 0);
    u(this, E, void 0);
    u(this, k, void 0);
    u(this, y, void 0);
    u(this, v, void 0);
    u(this, P, void 0);
    l(this, j, pe()), l(this, T, Ee()), l(this, E, /* @__PURE__ */ new Set()), l(this, k, []), l(this, y, new ke(c(this, j), c(this, T))), l(this, v, new Re(c(this, j), c(this, T))), l(this, P, () => {
      const e = [
        qe,
        He,
        Je,
        Fe,
        rt,
        Xe,
        et,
        Ge(this)
      ], n = We(async (r) => {
        await Promise.all(c(this, k).map((i) => i(r)));
      });
      this.use(e.concat(n));
    }), this.use = (e) => ([e].flat().forEach((n) => {
      c(this, E).add(n(c(this, v)));
    }), this), this.config = (e) => (c(this, k).push(e), this), this.create = async () => (c(this, P).call(this), await Promise.all([...c(this, E)].map((e) => e(c(this, y)))), this), this.action = (e) => e(c(this, y));
  }
  static make() {
    return new Q();
  }
  get ctx() {
    return c(this, y);
  }
};
let he = Q;
j = new WeakMap(), T = new WeakMap(), E = new WeakMap(), k = new WeakMap(), y = new WeakMap(), v = new WeakMap(), P = new WeakMap();
export {
  tt as CommandManager,
  G as CommandsReady,
  I as ConfigReady,
  he as Editor,
  $ as EditorStateReady,
  B as EditorViewReady,
  R as InitReady,
  A as ParserReady,
  M as SchemaReady,
  W as SerializerReady,
  _ as ThemeEnvironmentReady,
  F as ThemeReady,
  rt as commands,
  nt as commandsCtx,
  de as commandsTimerCtx,
  We as config,
  yt as createCmd,
  Ct as createCmdKey,
  oe as defaultValueCtx,
  Be as editorCtx,
  Xe as editorState,
  b as editorStateCtx,
  se as editorStateOptionsCtx,
  ie as editorStateTimerCtx,
  et as editorView,
  q as editorViewCtx,
  ae as editorViewOptionsCtx,
  me as editorViewTimerCtx,
  Ue as getDoc,
  Ge as init,
  Z as initTimerCtx,
  ge as inputRulesCtx,
  fe as markViewCtx,
  K as marksCtx,
  Ce as nodeViewCtx,
  D as nodesCtx,
  Je as parser,
  L as parserCtx,
  te as parserTimerCtx,
  S as prosePluginsCtx,
  O as remarkCtx,
  ye as remarkPluginsCtx,
  ce as rootCtx,
  He as schema,
  V as schemaCtx,
  x as schemaTimerCtx,
  Fe as serializer,
  ne as serializerCtx,
  re as serializerTimerCtx,
  qe as themeEnvironment,
  gt as themeFactory,
  Y as themeTimerCtx
};
//# sourceMappingURL=index.es.js.map
